import type { OHLCV } from '@shared/types/candle'
import { useMemo } from 'react'

import type { OhlcvBar } from '@/hooks/useCandles'
import { getIndicator } from '@/indicators/registry'
import type { ActiveIndicator } from '@/types/chart'
import type { IndicatorResult } from '@/types/indicator'

export function useIndicatorValues(
  bars: OhlcvBar[],
  indicators: ActiveIndicator[]
): Map<string, IndicatorResult> {
  return useMemo(() => {
    if (!bars.length || !indicators.length) return new Map<string, IndicatorResult>()

    const candles: OHLCV[] = bars.map((b) => ({
      t: b.time,
      o: b.open,
      h: b.high,
      l: b.low,
      c: b.close,
      v: b.value ?? 0,
    }))

    const results = new Map<string, IndicatorResult>()
    for (const ind of indicators) {
      const entry = getIndicator(ind.id)
      if (!entry) continue
      try {
        const instance = new entry.cls()
        results.set(ind.instanceId, instance.calculate(candles, ind.params))
      } catch {
        // Skip indicators that fail (e.g. insufficient data)
      }
    }
    return results
  }, [bars, indicators])
}
